import { motion } from "motion/react"

const Enconstruccion = () => {
    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center bg-dark text-light">
            <div className="container">
                <div className="row align-items-center text-center text-md-start">

                    <div className="col-md-12 text-center">
                        <motion.img
                            src={'/img/cumbresLogoff.png'}
                            alt="Sitio en construcción"
                            className="img-fluid"
                            style={{ maxWidth: "250px" }}
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.6 }}
                        />
                    </div>

                    {/* Imagen */}
                    <div className="col-md-6 mb-4 mb-md-0 d-flex justify-content-center">
                        <motion.img
                            src={'/img/construccion.png'}
                            alt="Sitio en construcción"
                            className="img-fluid"
                            style={{ maxWidth: "400px" }}
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.6 }}
                        />
                    </div>

                    {/* Texto */}
                    <div className="col-md-6">
                        <motion.h1
                            className="display-5 fw-bold mb-3"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2 }}
                        >
                            Estamos construyendo algo increíble 🚧
                        </motion.h1>

                        <motion.p
                            className="text-secondary mb-4"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.4 }}
                        >
                            Esta sección se encuentra en desarrollo.
                            Muy pronto estará disponible con nuevas funcionalidades
                            y una mejor experiencia.
                        </motion.p>

                        <motion.div
                            className="d-flex gap-3 justify-content-center justify-content-md-start"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.6 }}
                        >
                            <button
                                className="btn btn-primary px-4"
                                onClick={() => window.history.back()}
                            >
                                Regresar
                            </button>

                            <a
                                href="/"
                                className="btn btn-outline-light px-4"
                            >
                                Ir al inicio
                            </a>
                        </motion.div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Enconstruccion
